/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IServices } from '../services/ServicesTypes';
import { IReducerAction, IReducerActionData } from '../store/types/ReducerTypes';
import {
    IMultiAxisDataServiceDataLayout,
    IMultiAxisDataServiceDataLayoutMemberExpansion
} from '../store/types/MultiAxisDatasetTypes';
import { DrillDownInfo } from '../store/types/StateTypes';

const MultiAxisDataActions = {
    MULTI_AXIS_DATA_LOADED: 'MULTI_AXIS_DATA_LOADED',
    MULTI_AXIS_DATA_ERROR: 'MULTI_AXIS_DATA_ERROR',
    MULTI_AXIS_SET_LEVEL_EXPANDED_STATE: 'MULTI_AXIS_SET_LEVEL_EXPANDED_STATE',
    MULTI_AXIS_SET_MEMBER_EXPANDED_STATE: 'MULTI_AXIS_SET_MEMBER_EXPANDED_STATE',
    MULTI_AXIS_SET_MEMBERS_EXPANDED_STATE: 'MULTI_AXIS_SET_MEMBERS_EXPANDED_STATE',
    MULTI_AXIS_DRILLDOWN_TO: 'MULTI_AXIS_DRILLDOWN_TO'
};

function publishData(dataObj: any): IReducerAction<IReducerActionData> {
    return {
        type: MultiAxisDataActions.MULTI_AXIS_DATA_LOADED,
        data: { dataObj }
    };
}

function publishDataError(errorDescriptor: any): IReducerAction<IReducerActionData> {
    return {
        type: MultiAxisDataActions.MULTI_AXIS_DATA_ERROR,
        errorDescriptor
    };
}

function setLevelExpandedState(levelId: string, expanded: boolean, dynamicProperties: any): IReducerAction<IReducerActionData> {
    return {
        type: MultiAxisDataActions.MULTI_AXIS_SET_LEVEL_EXPANDED_STATE,
        data: { levelId, expanded, dynamicProperties }
    };
}

function setMemberExpandedState(memberExpansion: IMultiAxisDataServiceDataLayoutMemberExpansion, isColumns: boolean, dynamicProperties: any): IReducerAction<any> {
    return {
        type: MultiAxisDataActions.MULTI_AXIS_SET_MEMBER_EXPANDED_STATE,
        data: { memberExpansion, isColumns, dynamicProperties },
    };
}

function setMembersExpandedState(rowExpansions: IMultiAxisDataServiceDataLayoutMemberExpansion[], colExpansions: IMultiAxisDataServiceDataLayoutMemberExpansion[]): IReducerAction<any> {
    return {
        type: MultiAxisDataActions.MULTI_AXIS_SET_MEMBERS_EXPANDED_STATE,
        data: { rowExpansions, colExpansions }
    };
}

function loadMultiAxisData(dataLayout: IMultiAxisDataServiceDataLayout, startIndexRows: number, startIndexColumns: number, rowsCount: number, columnsCount: number) {
    return (dispatch: Function, getState: Function, services: IServices) => {
        services.multiAxisDataService.loadData(dataLayout, startIndexRows, startIndexColumns, rowsCount, columnsCount, getState())
            .then((responce: any) => {
                dispatch(publishData(responce));
            })
            .fail((errorDescriptor: any) => {
                dispatch(publishDataError(errorDescriptor));
            });
    };
}

function drillDownTo(info: DrillDownInfo) {
    return {
        type: MultiAxisDataActions.MULTI_AXIS_DRILLDOWN_TO,
        data: { info }
    };
}

export {
    MultiAxisDataActions, loadMultiAxisData, publishData, publishDataError, setLevelExpandedState, setMemberExpandedState, drillDownTo, setMembersExpandedState
};
